/**
 * TODO:
 * - update portfolio should hit API before updating state
 */
import { Portfolio } from 'api';
import * as action from './actionTypes';

export interface ICopyPortfolio {
    id: number,
    name: string
}

export const setActivePortfolio = (portfolio:Portfolio) => ({
    type: action.SET_ACTIVE_PORTFOLIO,
    payload: portfolio
})


export const getPortfolios = () => ({
    type: action.GET_PORTFOLIOS
})

export const getPortfoliosSuccess = (portfolios:Portfolio[]) => ({
    type: action.GET_PORTFOLIOS_SUCCESS,
    payload: portfolios
})

export const getPortfolio = (id:number) => ({
    type: action.GET_PORTFOLIO,
    payload: id
})
export const getPortfolioAndRedirect = (id:number, redirect:() => void) => ({
    type: action.GET_PORTFOLIO_AND_REDIRECT,
    payload: {id, redirect}
})

export const getPortfolioSuccess = (portfolio:Portfolio) => ({
    type: action.GET_PORTFOLIO_SUCCESS,
    payload: portfolio
})

// export const getPortfolioConfig = () => ({
//     type: action.GET_PORTFOLIO_CONFIG
// })

// export const getPortfolioConfigSuccess = (configData) => ({
//     type: action.GET_PORTFOLIO_CONFIG_SUCCESS,
//     payload: configData
// })

export const savePortfolio = (portfolio:Portfolio, redirect:() => void) => {
    return {
        type: action.SAVE_PORTFOLIO,
        payload: {portfolio, redirect}
    }
}

export const copyPortfolio = ({id, name}:ICopyPortfolio) => ({
    type: action.COPY_PORTFOLIO,
    payload: {id, name}
})

export const insertPortfolioToStore = (portfolio:Portfolio) => ({
    type: action.INSERT_PORTFOLIO_TO_STORE,
    payload: portfolio
})

export const savePortfolioSuccess = (portfolio:Portfolio) => ({
    type: action.SAVE_PORTFOLIO_SUCCESS,
    payload: portfolio
})

export const updatePortfolioList = (portfolios:Portfolio[]) => ({
    type: action.UPDATE_PORTFOLIO_LIST,
    payload: portfolios
})

export const discardActivePortfolio = () => ({
    type: action.DISCARD_ACTIVE_PORTFOLIO
})

export const portfolioApiError = (errorMsg:string) => ({
    type: action.PORTFOLIO_API_ERROR,
    payload: errorMsg
})

export const portfolioApiErrorClear = () => ({
    type: action.PORTFOLIO_API_ERROR_CLEAR
})